import React from 'react';

import { Theme } from '@lumapps/lumx/react';

/** Defines a context in which to apply the LumX Theme. */
export const ThemeContext = React.createContext<Theme>(Theme.light);

/** Get parent context Theme value. */
export const useThemeContext = () => React.useContext(ThemeContext);
